import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campus',
  templateUrl: './campus.component.html',
  styleUrls: ['./campus.component.scss']
})
export class CampusComponent implements OnInit {
  imgUrl=[
    '/assets/img/campus/1.jpg',
    '/assets/img/campus/2.jpg',
    '/assets/img/campus/3.jpeg',
    '/assets/img/campus/4.jpeg',
    '/assets/img/campus/5.jpeg',
    '/assets/img/campus/6.jpeg',
    '/assets/img/campus/7.jpeg',
    '/assets/img/campus/8.jpeg',
    '/assets/img/campus/9.jpeg',
    '/assets/img/campus/10.jpeg',
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
